import { errorToast, useToast } from "../../../components";
import { useSendGAEvent } from "../../../utils/googleAnalytics";
import {
  AddNewCallNoteMutation,
  CallNoteType,
  CallNoteVisibility,
} from "../../graphql";
import useAddCallNote from "../../graphql/hooks/useAddCallNote";

type UseAddNoteParams = {
  callId: string;
  onCompleted?: (data: AddNewCallNoteMutation) => void;
};

const useAddNote = ({
  callId,
  onCompleted,
}: UseAddNoteParams): ((note: {
  text: string;
  type: CallNoteType;
  time: number;
}) => Promise<void>) => {
  const sendGAEvent = useSendGAEvent();
  const toast = useToast();
  const [addCallNote] = useAddCallNote({
    call: { id: callId, __typename: "Call" },
    onCompleted,
    onError() {
      errorToast(toast, "There was a problem adding your note");
    },
  });

  return async ({ text, type, time }) => {
    if (
      text.trim() === "" &&
      [CallNoteType.Note, CallNoteType.Comment].includes(type)
    ) {
      return;
    }

    sendGAEvent("call_note_added", "call_review");

    await addCallNote({
      variables: {
        callId,
        text,
        type,
        time,
        visibility: CallNoteVisibility.Public,
      },
    });
  };
};

export default useAddNote;
